import { AfterViewInit, Component, ElementRef, Input } from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";

export interface IInformationPanelItem {
  header: IUProperty<string>;
  description: IUProperty<string>;
}

@Component({
  selector: "app-information-panel-item",
  templateUrl: "./information-panel-item.component.html",
  styleUrls: ["./information-panel-item.component.less"],
})
export class InformationPanelItemComponent implements AfterViewInit {
  @Input() item: IInformationPanelItem;
  descriptionColor: IUProperty<string>;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
  }

}
